<script>
import Modal from "@/components/_Shared/Modal";
import ratingMixin from "@/mixins/ratingMixin";
import { mapActions } from "vuex";

export default {
  mixins: [ratingMixin],
  props: {
    professional_id: {
      type: String,
      required: true
    }
  },

  components: {
    Modal
  },

  data() {
    return {
      preloader: false,
      description: "",
      rating: 5
    };
  },

  methods: {
    ...mapActions("professionals", ["addFeedback"]),

    async submit() {
      try {
        let valid = await this.$validator.validateAll();

        if (valid) {
          this.preloader = true;

          let data = {
            professional_id: this.professional_id,
            description: this.description,
            rating: this.ratingToInt(this.rating)
          };

          await this.addFeedback(data);
          this.$emit("close");
          this.$emit("refresh");
          this.$emit("success", "Feedback adicionado com sucesso!", "success");
          this.preloader = false;
        } else {
          this.$emit("error", "Verifique os campos digitados!");
        }
      } catch (e) {
        this.$emit("error", "Ocorreu um erro ao adicionar o feedback!");
        this.preloader = false;
      }
    }
  }
};
</script>

<template>
  <modal
    title="ADICIONAR FEEDBACK"
    subtitle="Informe os dados do feedback"
    size="md"
    @close="$emit('close')"
  >
    <template slot="body">
      <v-text-field
        name="nota"
        :error-messages="errors.first('nota')"
        :error="errors.has('nota')"
        v-model="rating"
        label="nota"
        v-validate="'required|min_value:0|max_value:5|decimal:1'"
        hint="utilize pontos ao invés de virgulas. Ex: 4.5"
        persistent-hint
        required
      ></v-text-field>

      <v-textarea
        name="descrição"
        :error-messages="errors.first('descrição')"
        :error="errors.has('descrição')"
        v-validate="'required|max:1024'"
        label="descrição"
        v-model="description"
        required
      ></v-textarea>
    </template>

    <template slot="footer">
      <v-btn color="primary" outlined @click="$emit('close')">fechar</v-btn>
      <v-btn color="primary" :loading="preloader" @click="submit"
        >adicionar</v-btn
      >
    </template>
  </modal>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Professionals/Edit/Tabs/Ratings/Feedbacks/New.vue